var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from '../../icon/_base';
const Clear = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-clear ${className}`} {...other}>
      <g>
        <g id="Components/TreeSelect/Element/Icon/Clear" stroke="none" strokeWidth="1" fillRule="evenodd">
          <circle id="Oval" fill="#E6E9ED" cx="8" cy="8" r="8"/>
          <g id="Icon" transform="translate(2.000000, 2.000000)" fill="#8592A6">
            <path d="M9.84489312,2.42027192 C9.99133973,2.56671853 9.99133973,2.8041554 9.84489312,2.95060201 L6.79549513,6 L9.84489312,9.04939799 C9.99133973,9.1958446 9.99133973,9.43328147 9.84489312,9.57972808 L9.57972808,9.84489312 C9.43328147,9.99133973 9.1958446,9.99133973 9.04939799,9.84489312 L6,6.79549513 L2.95060201,9.84489312 C2.8041554,9.99133973 2.56671853,9.99133973 2.42027192,9.84489312 L2.15510688,9.57972808 C2.00866027,9.43328147 2.00866027,9.1958446 2.15510688,9.04939799 L5.2050352,5.99946967 L2.15510688,2.95060201 C2.00866027,2.8041554 2.00866027,2.56671853 2.15510688,2.42027192 L2.42027192,2.15510688 C2.56671853,2.00866027 2.8041554,2.00866027 2.95060201,2.15510688 L6.00053033,5.20397454 L9.04939799,2.15510688 C9.1958446,2.00866027 9.43328147,2.00866027 9.57972808,2.15510688 L9.84489312,2.42027192 Z" id="Path"/>
          </g>
        </g>
      </g>
    </Base>);
};
export default Clear;
